module.exports = __webpack_public_path__ + "img/vyshyvanka-day.7f490d81.webp";